import axios from 'axios';

export default class http {
    static async loadFile(method, url, formData, authHeader) {
        let response;
        try {
            response = await axios[method](url, formData, {
                headers: {
                    'Authorization': authHeader,
                    'Content-type': 'multipart/form-data'
                }
            });
        } catch (e) {
            response = {
                error: { message: e.message }
            };
        }
        return response;
    }
}
